import { render, staticRenderFns } from "./IEInfo.vue?vue&type=template&id=354659d1&scoped=true&"
var script = {}
import style0 from "./IEInfo.vue?vue&type=style&index=0&id=354659d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354659d1",
  null
  
)

export default component.exports